import dayjs from 'dayjs';

import {config} from 'config/env';

export enum ComplexPromotionCondition {
  AND = 'AND',
  ALL = 'ALL'
}

export enum RewardType {
  DISCOUNT = 'DISCOUNT',
  POINTS = 'POINTS',
  PERCENTAGE = 'PERCENTAGE'
}

export enum ComplexPromotionRewardTypeValues {
  DISCOUNT = 0,
  PERCENTAGE = 1
}

export enum ComplexPromotionType {
  MULTI_BUY = 'MULTI_BUY',
  MIX_MATCH = 'MIX_MATCH',
  SELLER_PROMO = 'SELLER_PROMO',
  BOGO = 'BOGO',
  COMBO_SET = 'COMBO_SET'
}

export const NUMBER_OF_PRODUCTS_TO_SHOW = 20;

export const PROPOINT_COLLECTION = 'PROPOINT_PROMOTION';
export const DEFAULT = 'DEFAULT';

export const TRANSLATION_KEYS = {
  PROPOINT: {
    TAG: 'loyalty.proPointPromotions.complexPromotion.proPoint',
    DESCRIPTION: 'loyalty.proPointPromotions.complexPromotion.subHeader'
  },
  [ComplexPromotionType.MULTI_BUY]: {
    TAG: 'loyalty.proPointPromotions.complexPromotion.multiBuy',
    DESCRIPTION: 'loyalty.proPointPromotions.complexPromotion.multiBuyHeader'
  },
  [ComplexPromotionType.MIX_MATCH]: {
    TAG: 'loyalty.proPointPromotions.complexPromotion.comboSet',
    DESCRIPTION: ''
  },
  [ComplexPromotionType.SELLER_PROMO]: {
    TAG: 'loyalty.proPointPromotions.complexPromotion.comboSet',
    DESCRIPTION: ''
  }
};

export const PROMOTION_COLORS = {
  PROPOINT: {
    BACKGROUND: '#FFF7D4',
    TEXT: '#835111'
  },
  DEFAULT: {
    BACKGROUND: '#EADEFF',
    TEXT: '#6109FF'
  }
};

export const buildStrapiCDNURL = (imageFileName: string): string => {
  const assetUrl = config.RECOM_APP_ASSETS_URL;
  const postfix = `?version=${dayjs().format('YYYYMMDDA')}`;

  return assetUrl + imageFileName + postfix;
};

export enum PROMOTION_REWARD {
  BATH_OFF = 'Get $ off',
  PERCENTAGE_OFF = 'Get % off',
  BATH_OFF_3P = 'AMOUNT_OFF',
  PERCENTAGE_OFF_3P = 'PERCENTAGE_OFF'
}

export const getRm3PromotionRewardType = (type: string) => {
  // string contain check
  if (type.includes(PROMOTION_REWARD.BATH_OFF)) {
    return PROMOTION_REWARD.BATH_OFF;
  }
  if (type.includes(PROMOTION_REWARD.PERCENTAGE_OFF)) {
    return PROMOTION_REWARD.PERCENTAGE_OFF;
  }
  return type;
};

export const determinePromotionType = (
  isBOGOEnabled: boolean,
  productDisplayPrice: number,
  discount: number,
  promotionTargetValue: number,
  promotionSubType: string
): string => {
  //The rule for BOGO is to buy 2x of the same product, and the discount is equal to the item’s selling price.
  const isBOGO =
    isBOGOEnabled &&
    productDisplayPrice === discount &&
    promotionTargetValue === 2 &&
    promotionSubType === ComplexPromotionType.MULTI_BUY;

  return isBOGO ? ComplexPromotionType.BOGO : promotionSubType;
};
